$(function () {
    // gsap.timeline({
    //   scrollTrigger: {
    //     trigger: '.scroll_image',
    //     start: 'bottom bottom',
    //     toggleClass: 'active',
    //     scrub: true,
    //   },
    // });

    // gsap.timeline({
    //     scrollTrigger: {
    //       trigger: ".t8530_feature_3",
    //       start: "bottom bottom",
    //       toggleClass: "active",
    //       scrub: true
    //     }
    // });

    // skrollr.init({
    //     edgeStrategy: 'set',
    //     easing: {
    //       WTF: Math.random,
    //       inverted: function(p) {
    //           return 1-p;
    //       }
    //     }
    // });

    $('.pro_co .pc_item').click(function() {
        $('.pro-img .pi_img').css('display', 'none');
        $('.pro_co .pc_item').removeClass('active');
        $('.pro-img .pi_img').eq($(this).index()).css('display', 'block');
        $(this).addClass('active');
    });

});